export class AccordionViewModel {
    title?: string | undefined;
    formattedText?: string | undefined;
    accordionId?: string | undefined;
}


